export default function innerProduct(v1, v2) {
  let result = 0;
  for (let idx = 0; idx < v1.length; idx++) {
    result += v1[idx] * v2[idx];
  }
  return result;
}
